module.exports = __webpack_public_path__ + "static/media/Logo_white.735e2e45.svg";